import { render, staticRenderFns } from "./CourseTree.vue?vue&type=template&id=6bbf2cf0&scoped=true&"
import script from "./CourseTree.vue?vue&type=script&lang=js&"
export * from "./CourseTree.vue?vue&type=script&lang=js&"
import style0 from "./CourseTree.vue?vue&type=style&index=0&id=6bbf2cf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbf2cf0",
  null
  
)

export default component.exports